import styled from "styled-components";

export const ContainerFlex = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};
  height: 100%;

  @media (max-width: 1300px) {
    padding-bottom: 20px;
    flex-direction: column;
    height: auto;
  }
`;

export const ContainerColumnFlex = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;

  @media (max-width: 1300px) {
    flex-direction: column-reverse;
    gap: ${({ theme }) => theme.spacing.medium};
    justify-content: normal;
    height: auto;
  }
`;

export const CardsColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 1300px) {
    flex-direction: row;
    width: 100%;
  }

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: start;
  margin-top: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 1300px) {
    margin-top: 0;
  }
`;

export const ButtonLabel = styled.div`
  margin-left: 5px;
`;

export const SearchContainer = styled.div`
  width: 300px;

  @media (max-width: 700px) {
    width: 100%;
  }
`;

export const NotActivatedFlex = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
  margin-top: 0.5rem;
`;

export const SendLinkButton = styled.div`
  display: flex;
  gap: 5px;
  padding: 5px 15px;
  align-items: center;
  font-weight: 500;
  background-color: ${({ theme }) => theme.colors.lightGrey};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  cursor: pointer;
  transition: color 0.3s, background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryLight};
    color: ${({ theme }) => theme.colors.primary};
  }

  &:hover svg {
    color: ${({ theme }) => theme.colors.primary};
  }

  &.active {
    background-color: ${({ theme }) => theme.colors.primaryLight};
    color: ${({ theme }) => theme.colors.primary};
  }

  &.active svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
